import { gql } from "apollo-boost";

const VIEWER = gql`
  query Viewer {
    viewer {
      id
    }
  }
`;

export default VIEWER;
